<template>
    <div class="gray-80">
        <div class="flex-row jc-space">
            <div class="mb-1">
                <span class="gray-100 fs-10 bold lh-32">{{ value }}</span>
                <span class="fs-3 lh-big">/ {{ total }}</span>
            </div>
            <div class="mb-1 self-end">
                {{ $l10n.n__('%d licence restante', '%d licences restantes', rest, rest) }}
            </div>
        </div>
        <el-progress
            :stroke-width="4"
            :percentage="progress"
            :format="() => {}"
            :textInside="true"
            :status="status"
        ></el-progress>
    </div>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
            required: true,
            validator: function (value) {
                return value > 0;
            },
        },
        value: {
            type: Number,
            required: true,
            validator: function (value) {
                return value >= 0;
            },
        },
        status: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        rest: function () {
            return this.total - this.value;
        },
        progress: function () {
            return Math.min((this.value * 100) / this.total, 100);
        },
    },
    created() {
        if (this.value > this.total) {
            throw Error('Value cannot excess total');
        }
    },
};
</script>
<style scoped>
.fs-10 {
    font-size: 40px;
}
.self-end {
    align-self: flex-end;
}
</style>
